<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="titlePage mb-3">Analise de fotos</div>
      </b-col>
    </b-row>
    <b-form @submit.prevent="filtrarLista(true)">
      <b-row>
        <b-col cols="3" class="mb-3">
          <fcc-select
            v-model="tipoSelecionado"
            valueField="tipo"
            labelField="label"
            :clearable="false"
            :options="tipoDeBusca"
          >
            Tipo de Busca
          </fcc-select>
        </b-col>
        <b-col cols="5" v-if="tipoSelecionado === 'id'">
          <fcc-input v-model="search" extra-classes="inputLabel mb-2" required> ID </fcc-input>
        </b-col>
        <b-col cols="5" v-if="tipoSelecionado === 'cpf'">
          <fcc-input v-model="search" extra-classes="inputLabel mb-2" required> CPF </fcc-input>
        </b-col>
        <b-col cols="5" v-if="tipoSelecionado === 'nome'">
          <fcc-input v-model="search" extra-classes="inputLabel mb-2" required> Nome </fcc-input>
        </b-col>
        <b-col cols="2">
          <fcc-button tipo="submit" extra-classes="inputLabel mb-2"> Buscar </fcc-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row v-if="!validacaoFinalizada && fotoAnalise.length > 0">
      <b-col cols="12">
        <div>
          <b-col
            align-h="center"
            class="mb-4 text-center"
            v-for="(foto, i) in fotoAnalise"
            v-show="i == itemAtual"
            :key="i"
          >
            <img width="230px" :src="foto.url" class="analise-img" alt="foto" />

            <b-col class="mt-4 mx-auto">
              <fcc-button
                class="buttonSol mx-2"
                @click="proximaFoto(false)"
                color="outline-primary"
                v-if="(itemAtual > 0 && pagAtual > 0) || pagAtual > 1"
                ><font-awesome-icon icon="chevron-left" size="lg" />
              </fcc-button>
              <fcc-button class="buttonSol mx-2" @click="enviarAnalise(true, foto.id)"
                >Aprovar</fcc-button
              >
              <fcc-button
                class="buttonSol mx-2"
                @click="enviarAnalise(false, foto.id)"
                color="outline-primary"
                >Reprovar</fcc-button
              ><fcc-button
                class="buttonSol mx-2"
                color="outline-primary"
                @click="proximaFoto(true)"
                v-if="itemAtual < totalItens && pagAtual < totalPagina"
                ><font-awesome-icon icon="chevron-right" size="lg" />
              </fcc-button>
              <div class="text-left mt-3">
                <div class="text-center">
                  <strong>ID Foto:</strong> {{ foto.id }} - <strong>CPF:</strong>
                  {{ stringLGPD(foto.cpf, 3) }} - <strong>Nome:</strong>
                  {{ stringLGPD(foto.nome, 3, 0, true) }}
                </div>
                <strong>Total de foto(s): </strong>
                {{ fotoAnalise[0].totalpagina }}<br />
                <strong>Total de página(s): </strong> {{ totalPagina }}
              </div>
            </b-col>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-alert v-else-if="validacaoFinalizada" show variant="success"
      >Validação de fotos concluida. {{ controlePage }}</b-alert
    >
    <b-alert v-else show variant="warning"
      >O projeto {{ controlePage }} não possui fotos para validação.</b-alert
    >
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  props: {
    controlePage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      titlePage: 'Analise de fotos',
      baseUrlAnaliseFotos: '',
      fotoAnalise: [],
      totalItens: 0,
      totalPagina: 0,
      pagAtual: 1,
      pageSize: 50,
      acao: false,
      itemAtual: 0,
      idAtual: null,
      validacaoFinalizada: false,
      campoBusca: '',
      sortBy: 'datainicio',
      tipoSelecionado: 'todas',
      tipoDeBusca: [
        { label: 'Todas', tipo: 'todas' },
        { label: 'Buscar por ID', tipo: 'id' },
        { label: 'Buscar por CPF', tipo: 'cpf' },
        { label: 'Buscar por nome', tipo: 'nome' }
      ],
      search: ''
    }
  },
  methods: {
    proximaFoto(acao) {
      this.acao = true
      const itemActual = this.itemAtual + 1
      const itemActualMenos = this.itemAtual - 1
      if (acao && itemActual < this.pageSize) {
        this.itemAtual = itemActual
      } else if (acao && itemActual == this.pageSize) {
        this.itemAtual = 0
        this.pagAtual = this.pagAtual + 1
        this.filtrarLista()
      }
      if (!acao && this.itemAtual > 0) {
        this.itemAtual = itemActualMenos
        this.acao = false
      } else if (!acao && this.itemAtual == 0) {
        this.itemAtual = 0
        this.pagAtual = this.pagAtual - 1
        this.acao = false
        this.filtrarLista()
      }
    },
    getListaFotos(page) {
      this.fotoAnalise = []
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlAnaliseFotos +
            `ListarFotosPaginadas?PageNumber=${page}&PageSize=${this.pageSize}&spi=${this.controlePage}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          let res = response.data
          this.fotoAnalise = res.fotos
          this.totalPagina = res.totalpagina
          this.totalItens = this.fotoAnalise.length
          this.itemAtual = this.acao ? 0 : this.pageSize - 1
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    getId() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlAnaliseFotos + `ListarFotosPorId?id=${this.search}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.fotoAnalise = []
          if (response.status == 299) {
            let res = response.data

            this.totalPagina = res.totalpagina
            this.totalItens = this.fotoAnalise.length
            this.fotoAnalise = [res]
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    getCpf() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlAnaliseFotos +
            `ListarFotosPorCpf?PageNumber=${this.pagAtual}&PageSize=${this.pageSize}&cpf=${this.search}&spi=${this.controlePage}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.fotoAnalise = []
          let res = response.data
          this.fotoAnalise.push(...res)
          this.totalPagina = res.length > 0 ? res[0].totalpagina - 1 : 0
          this.totalItens = this.fotoAnalise.length
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    getNome() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlAnaliseFotos +
            `ListarFotosPorNome?PageNumber=${this.pagAtual}&PageSize=${this.pageSize}&nome=${this.search}&spi=${this.controlePage}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          let res = response.data
          this.totalPagina = res.length > 0 ? res[0].totalpagina - 1 : 0

          this.totalItens = this.fotoAnalise.length
          this.fotoAnalise = res
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    analisePut(valida, id) {
      const data = {
        id: id,
        valida: valida
      }
      axios
        .put(
          this.baseUrlAnaliseFotos + 'GravarValidacao',
          data,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.proximaFoto(true)
        })
        .catch(this.setErrorSystem)
    },
    enviarAnalise(analise, id) {
      this.analisePut(analise, id)
    },
    filtrarLista(zeraPagina = false) {
      this.pagAtual = zeraPagina ? (this.pagAtual = 1) : this.pagAtual
      this.itemAtual = zeraPagina ? 0 : this.itemAtual
      switch (this.tipoSelecionado) {
        case 'id':
          this.getId()
          break
        case 'nome':
          this.getNome()
          break
        case 'cpf':
          this.getCpf()
          break
        case 'todas':
          this.getListaFotos(this.pagAtual)
          break
      }
    }
  },
  watch: {
    pagAtual() {
      this.itemAtual = 0
    },
    tipoSelecionado() {
      // this.pagAtual = 0
    }
  },
  mounted() {
    this.baseUrlAnaliseFotos = store.state.baseUrlAnaliseFotos
    this.acao = true
    this.getListaFotos(this.pagAtual)
  }
}
</script>
<style>
.analise-img {
  border-radius: 15px;
  box-shadow: 4px 5px 5px #0000003d;
}
</style>
